import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import MetricHelpIcon from './MetricHelpIcon';

const MainKPICard = ({ 
  title, 
  value, 
  comparisonData,
  formatter = (val) => val,
  isLowerBetter = false, // For metrics like bounce rate where lower is better
  helpKey = null // Key for metric help tooltip
}) => {
  const deltaPercent = comparisonData?.deltaPercent;
  
  // Determine if change is positive (good) or negative (bad)
  let isPositive = false;
  let isNegative = false;
  let isNeutral = true;
  
  if (deltaPercent !== null && deltaPercent !== undefined && deltaPercent !== 0) {
    isNeutral = false;
    
    if (isLowerBetter) {
      // For metrics like bounce rate, decrease is good
      isPositive = deltaPercent < 0;
      isNegative = deltaPercent > 0;
    } else {
      // For metrics like conversion rate, increase is good
      isPositive = deltaPercent > 0;
      isNegative = deltaPercent < 0;
    }
  }
  
  const getIcon = () => {
    if (isNeutral) return <Minus className="h-4 w-4" />;
    if (isLowerBetter) {
      return deltaPercent < 0 ? <TrendingDown className="h-4 w-4" /> : <TrendingUp className="h-4 w-4" />;
    }
    return deltaPercent > 0 ? <TrendingUp className="h-4 w-4" /> : <TrendingDown className="h-4 w-4" />;
  };
  
  const getColor = () => {
    if (isNeutral) return 'text-muted-foreground';
    if (isPositive) return 'text-green-600';
    if (isNegative) return 'text-red-600';
    return 'text-muted-foreground';
  };
  
  const getBgColor = () => {
    if (isNeutral) return 'bg-slate-50';
    if (isPositive) return 'bg-green-50';
    if (isNegative) return 'bg-red-50';
    return 'bg-slate-50';
  };
  
  const formatDeltaPercent = (val) => {
    if (val === null || val === undefined) return null;
    const sign = val > 0 ? '+' : '';
    return `${sign}${val.toFixed(1).replace('.', ',')}%`;
  };

  return (
    <Card className="border-2">
      <CardHeader className="pb-3">
        <CardTitle className="text-sm font-medium text-muted-foreground flex items-center gap-1.5">
          {title}
          {helpKey && <MetricHelpIcon metricKey={helpKey} />}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-3xl font-bold mb-3">{formatter(value)}</div>
        
        {deltaPercent !== null && deltaPercent !== undefined ? (
          <div className={`flex items-center gap-2 text-sm font-medium ${getColor()}`}>
            {getIcon()}
            <span>{formatDeltaPercent(deltaPercent)} em relação ao período anterior</span>
          </div>
        ) : (
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Minus className="h-4 w-4" />
            <span>Sem dados do período anterior</span>
          </div>
        )}
        
        {/* Previous value for context */}
        {comparisonData?.previous !== null && comparisonData?.previous !== undefined && (
          <div className="mt-2 pt-2 border-t">
            <p className="text-xs text-muted-foreground">
              Período anterior: {formatter(comparisonData.previous)}
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default MainKPICard;
